import React, { FC, MouseEvent } from 'react';
import Svg from 'svg-inline-react';
import classnames from 'classnames';
import FrSpeechBubbleSvg from '@src/svgs/fr-speech-bubble.svg';
import { OpenChatProps } from './props';
import './styles.scss';

export const OpenChatButton: FC<OpenChatProps> = ({ onOpenChat, isUnread }) => {
  const onClick = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    onOpenChat();
  };

  return (
    <div className="opening-applicant-card-open-chat" onClick={onClick}>
      <div
        className={classnames(
          'opening-applicant-card-open-chat__action-icon-wrapper',
          isUnread && 'opening-applicant-card-open-chat__action-icon-wrapper--unread',
        )}
      >
        <Svg className="opening-applicant-card-open-chat__action-icon" src={FrSpeechBubbleSvg} />
      </div>
      Open chat
    </div>
  );
};
